import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GetPrivilegesDownloadQueryResult, useGetPrivilegesDownload } from '../../../../api/privilege/privilege';
import { useOptionsForBinary } from '../../../../hooks/api';
import { executeDownload } from '../../../../utils/download';
import BlobErrorModal from '../../../modules/BlobErrorModal';
import SpinnerModal from '../../../modules/SpinnerModal';

// ダウンロードボタン
function PrivilegesDownload() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const optionsForBinary = useOptionsForBinary(language);

  // スピナーモーダルを表示する
  const [displaySpinnerModal, setDisplaySpinnerModal] = useState(false);

  // エラーダイアログ
  const [displayDownloadError, setDisplayDownloadError] = useState(false);

  const { refetch, isError, error } = useGetPrivilegesDownload<GetPrivilegesDownloadQueryResult, AxiosError<Blob>>(
    optionsForBinary
  );

  useEffect(() => {
    setDisplayDownloadError(isError);
  }, [isError]);

  // ダウンロード処理
  const downloadAsync = useCallback(async () => {
    setDisplaySpinnerModal(true);
    const response = await refetch();
    if (response.status === 'success') {
      executeDownload(response.data);
      setDisplaySpinnerModal(false);
    } else {
      setDisplaySpinnerModal(false);
    }
  }, [refetch]);

  return (
    <>
      <a href="#download" onClick={() => downloadAsync()}>
        <i className="fa-solid fa-download" />
        {t('ダウンロード')}
      </a>
      {/* スピナーモーダル */}
      {displaySpinnerModal && <SpinnerModal />}
      {/* 出力エラー */}
      {displayDownloadError && <BlobErrorModal error={error} onClickOk={() => setDisplayDownloadError(false)} />}
    </>
  );
}

export { PrivilegesDownload };
